import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { SenaceService } from 'src/app/services/senace.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-detalle-estudio',
  templateUrl: './detalle-estudio.component.html',
  styleUrls: ['./detalle-estudio.component.css']
})
export class DetalleEstudioComponent implements OnInit {
  participacion: number;
  sector: any;
  actividad: any;
  expediente: any;
  proyecto: any;
  url:any;
  idSolicitud: number;
  token : any;
  idProyecto:any;

  constructor(
    private senaceService: SenaceService,
    private activatedRoute: ActivatedRoute,
    private localStorage: LocalStorage
  ) {
    this.localStorage.getItem('detalle').subscribe(
      (resp: any) => {
        console.log('storage___', resp);
        
        this.idSolicitud  = resp.proyectoId;
        this.participacion = resp.participacion;

        if (resp.solicitud.sector) {
          this.sector = resp.solicitud.sector;
        }
        if (resp.solicitud.actividad) {
          this.actividad = resp.solicitud.actividad;
        }
        if (resp.correlativo) {
          this.expediente = resp.correlativo;
        }
        if (resp.titulo) {
          this.proyecto = resp.titulo;
        }
        if (resp.fechaRegistro) {
          this.proyecto = `${this.proyecto} - ${resp.fechaRegistro}`;
        }
        if(resp.url){
          this.url = resp.url;
        }
      }
    )
  }

  ngOnInit() {
  }

  VerEstudioEva(expe){
    Swal.fire({
      text: 'Cargando pagina ...',
      icon: 'info',
      showCancelButton: false
    });    

    Swal.showLoading();

    this.senaceService.getGeneraToken(expe)
      .subscribe(
        (response) => {
          Swal.close();          

          this.token = response[0].TOKEN;

          console.log(this.token);

          window.open(`https://eva.senace.gob.pe:8443/plan/senace/token?tk=${this.token}`, "_blank");          

        }, (error) => {
          Swal.fire({
            title: 'Aviso',
            text: 'Error al generar token. Intente nuevamente',
            icon: 'error',
            confirmButtonText: 'Aceptar'
          })
        }        
      )
  }

}
